import React from "react";
import {css, Theme} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

export interface IProps {
    link: {
        name: string;
        url: string;
    };
}

export const ArticleCategoriesLinksItem: React.FC<IProps> = (props) => {
    return (
        <li css={linkLi}>
            <a href={props.link.url} css={linkA} rel="noreferrer">
                {props.link.name}
            </a>
        </li>
    );
};

const linkLi = css`
    list-style-type: none;
    ${mb(1)};
`;

const linkA = (theme: Theme) => css`
    line-height: 4rem;
    display: inline-block;
    color: ${theme.colors.gray[700]};
    ${getTextVariantStyleFor("body_copy_2")(theme)}
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {mb} from "@pg-design/helpers-css";
import {getTextVariantStyleFor} from "@pg-design/text";

export interface IProps {
    link: {
        name: string;
        url: string;
    };
}

export const ArticleCategoriesLinksItem: React.FC<IProps> = (props) => {
    return (
        <li css={linkLi}>
            <a href={props.link.url} css={linkA} rel="noreferrer">
                {props.link.name}
            </a>
        </li>
    );
};

const linkLi = css`
    list-style-type: none;
    ${mb(1)};
`;

const linkA = (theme: Theme) => css`
    line-height: 4rem;
    display: inline-block;
    color: ${theme.colors.gray[700]};
    ${getTextVariantStyleFor("body_copy_2")(theme)}
`;
